import React, { useState, useEffect, useRef, useCallback } from "react";

const testimonials = [
  {
    name: "Arun Kumar",
    rating: 5,
    date: "2 months ago",
    review:
      "An unforgettable experience! The private theatre setup was classy and perfectly maintained. Totally worth it for special occasions.",
  },
  {
    name: "Sneha R",
    rating: 5,
    date: "3 weeks ago",
    review:
      "HexaPlay made our anniversary magical. From décor to ambience everything felt premium and personal.",
  },
  {
    name: "Vignesh P",
    rating: 4,
    date: "1 month ago",
    review:
      "Loved the privacy and comfort. Sound quality and screen clarity were impressive.",
  },
  {
    name: "Meera S",
    rating: 5,
    date: "2 weeks ago",
    review:
      "Best place for surprises! Booking was easy and the team handled everything smoothly.",
  },
  {
    name: "Rahul & Anu",
    rating: 5,
    date: "1 month ago",
    review:
      "We celebrated a proposal here and it was beyond expectations.",
  },
  {
    name: "Karthik M",
    rating: 4,
    date: "3 months ago",
    review:
      "Very premium feel. Perfect for birthdays and private celebrations.",
  },
];

const faqs = [
  {
    question: "What is a private theatre?",
    answer:
      "A private theatre is a theatre room booked only for you and your group, so you can watch movies or celebrate without sharing the space with other guests. At HexaPlay, the theatre comes pre-decorated and ready to celebrate.",
  },
  {
    question:
      "Can I celebrate a birthday or anniversary in a private theatre?",
    answer:
      "Yes. HexaPlay private theatres are designed for birthdays, anniversaries, date nights, proposals, bride-to-be parties and kids’ celebrations. You can add cakes, food, bouquets, gifts and other add-ons.",
  },
  {
    question: "Does HexaPlay offer gaming?",
    answer:
      "Yes. HexaPlay offers gaming experiences for friends, groups and gaming enthusiasts, and gaming can be added to celebrations. Please contact your chosen branch to confirm the available games and equipment.",
  },
  {
    question: "How do I book a private theatre at HexaPlay?",
    answer:
      "Choose your branch, then use the Book Your Experience form, WhatsApp or phone to share your occasion, date, time and guest count. Our team will confirm availability.",
  },
  {
    question: "Which movies or shows can we watch?",
    answer:
      "Guests can connect their OTT accounts or use available HexaPlay subscriptions to stream movies, series or YouTube content. Availability may depend on the branch and applicable service subscriptions.",
  },
  {
    question: "What is the refund policy?",
    answer:
      "Please check the booking terms applicable to your reservation or contact the HexaPlay team to confirm the cancellation and refund conditions before booking.",
  },
  {
    question: "Are washrooms available?",
    answer:
      "Please contact your selected HexaPlay branch to confirm the facilities available at that location.",
  },
  {
    question: "Are kids chargeable?",
    answer:
      "Child pricing may depend on the applicable branch policy and booking package. Please confirm the charges with the HexaPlay team before booking.",
  },
  {
    question: "What if there is a technical interruption?",
    answer:
      "If you experience a technical interruption during your booking, please notify the staff immediately so the team can assist you and explain any applicable resolution or refund policy.",
  },
  {
    question: "Are we responsible for our belongings?",
    answer:
      "Guests should take care of their personal belongings during their visit. Please contact the branch team if you need assistance with a lost or misplaced item.",
  },
];

const avatarColors = [
  "#4285F4",
  "#EA4335",
  "#34A853",
  "#FBBC05",
  "#9333ea",
  "#0ea5e9",
];

const TestimonialsFaq = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const autoPlayRef = useRef(null);
  const pauseTimerRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const toggleFaq = (index) => {
    setActiveIndex((previous) => (previous === index ? null : index));
  };

  const goToNext = useCallback(() => {
    setCurrentSlide((previous) =>
      previous === testimonials.length - 1 ? 0 : previous + 1
    );
  }, []);

  const goToPrev = useCallback(() => {
    setCurrentSlide((previous) =>
      previous === 0 ? testimonials.length - 1 : previous - 1
    );
  }, []);

  const pauseAndResume = useCallback(() => {
    setIsPaused(true);
    clearTimeout(pauseTimerRef.current);

    pauseTimerRef.current = setTimeout(() => {
      setIsPaused(false);
    }, 5000);
  }, []);

  useEffect(() => {
    clearInterval(autoPlayRef.current);

    if (!isPaused) {
      autoPlayRef.current = setInterval(goToNext, 3500);
    }

    return () => clearInterval(autoPlayRef.current);
  }, [isPaused, goToNext]);

  useEffect(() => {
    return () => {
      clearInterval(autoPlayRef.current);
      clearTimeout(pauseTimerRef.current);
    };
  }, []);

  const handleTouchStart = (event) => {
    touchStartX.current = event.targetTouches[0].clientX;
    touchEndX.current = event.targetTouches[0].clientX;
    setIsPaused(true);
  };

  const handleTouchMove = (event) => {
    touchEndX.current = event.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    const distance = touchStartX.current - touchEndX.current;

    if (Math.abs(distance) > 40) {
      if (distance > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }

    pauseAndResume();
  };

  return (
    <>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

        .tf-section {
          width: 100%;
          padding: 76px 20px 70px;
          background: #f8f9fc;
          font-family: "Poppins", sans-serif;
          overflow: hidden;
          box-sizing: border-box;
        }

        .tf-section *,
        .tf-section *::before,
        .tf-section *::after {
          box-sizing: border-box;
        }

        .tf-section .section-title {
          margin: 0 0 38px;
          color: #17152a;
          font-size: clamp(26px, 3.2vw, 36px);
          line-height: 1.3;
          font-weight: 700;
          letter-spacing: -0.5px;
          text-align: center;
        }

        .tf-testimonials {
          max-width: 1200px;
          margin: 0 auto;
        }

        .testimonial-container {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 22px;
        }

        .testimonial-card {
          min-width: 0;
          padding: 24px;
          background: #fff;
          border: 1px solid #e9e7f1;
          border-radius: 16px;
          box-shadow: 0 5px 20px rgba(36, 24, 74, 0.035);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .testimonial-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(36, 24, 74, 0.09);
        }

        .review-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 13px;
        }

        .avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          flex: 0 0 44px;
          border-radius: 50%;
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }

        .review-user {
          min-width: 0;
        }

        .review-user h4 {
          margin: 0 0 3px;
          color: #201b36;
          font-size: 14px;
          font-weight: 600;
        }

        .review-user span {
          color: #858397;
          font-size: 12px;
        }

        .google-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          flex: 0 0 30px;
          margin-left: auto;
          border: 1px solid #e9e7ef;
          border-radius: 50%;
          color: #4285f4;
          background: #fff;
          font-size: 16px;
          font-weight: 700;
        }

        .stars {
          margin-bottom: 12px;
          color: #f4b400;
          font-size: 17px;
          letter-spacing: 2px;
        }

        .review-text {
          margin: 0;
          color: #656276;
          font-size: 13.5px;
          line-height: 1.8;
        }

        .mobile-testimonial-slider {
          display: none;
        }

        .tf-faq {
          max-width: 900px;
          margin: 86px auto 0;
          scroll-margin-top: 90px;
        }

        .tf-faq .section-title {
          margin-bottom: 12px;
        }

        .faq-intro {
          max-width: 650px;
          margin: 0 auto 32px;
          color: #737185;
          text-align: center;
          font-size: 14px;
          line-height: 1.8;
        }

        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 13px;
        }

        .faq-card {
          overflow: hidden;
          border: 1px solid #e8e5f0;
          border-radius: 13px;
          background: #fff;
          transition: border-color 0.25s ease, box-shadow 0.25s ease;
        }

        .faq-card:hover,
        .faq-card.active {
          border-color: #8b7ce8;
          box-shadow: 0 7px 22px rgba(76, 58, 143, 0.07);
        }

        .faq-question {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          width: 100%;
          padding: 20px 22px;
          border: 0;
          background: transparent;
          color: #201b36;
          font-family: inherit;
          font-size: 15px;
          font-weight: 600;
          line-height: 1.6;
          text-align: left;
          cursor: pointer;
        }

        .faq-question span:first-child {
          flex: 1;
        }

        .faq-question:focus-visible,
        .faq-btn:focus-visible,
        .t-arrow:focus-visible,
        .t-dot:focus-visible {
          outline: 3px solid #a29bfe;
          outline-offset: 3px;
        }

        .faq-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 31px;
          height: 31px;
          flex: 0 0 31px;
          border-radius: 50%;
          background: #f0edff;
          color: #5944c5;
          font-size: 22px;
          font-weight: 400;
          line-height: 1;
          transition: transform 0.25s ease, background 0.25s ease;
        }

        .faq-card.active .faq-icon {
          transform: rotate(45deg);
          background: #6048d8;
          color: #fff;
        }

        .faq-answer {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.3s ease;
        }

        .faq-card.active .faq-answer {
          grid-template-rows: 1fr;
        }

        .faq-answer-inner {
          overflow: hidden;
        }

        .faq-answer p {
          margin: 0;
          padding: 0 22px 21px;
          color: #69677a;
          font-size: 14px;
          line-height: 1.85;
        }

        .faq-btn-wrapper {
          margin-top: 34px;
          text-align: center;
        }

        .faq-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 48px;
          padding: 13px 28px;
          border: 0;
          border-radius: 50px;
          background: linear-gradient(135deg, #4c3a8f, #7160df);
          box-shadow: 0 8px 20px rgba(76, 58, 143, 0.2);
          color: #fff;
          font-family: inherit;
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .faq-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 26px rgba(76, 58, 143, 0.3);
        }

        @media (max-width: 900px) {
          .testimonial-container {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 768px) {
          .tf-section {
            padding: 54px 16px 48px;
          }

          .tf-section .section-title {
            margin-bottom: 28px;
            font-size: 27px;
          }

          .testimonial-container {
            display: none;
          }

          .mobile-testimonial-slider {
            display: block;
            width: 100%;
            max-width: 520px;
            margin: 0 auto;
          }

          .t-progress-bar {
            width: 100%;
            height: 4px;
            margin-bottom: 20px;
            overflow: hidden;
            border-radius: 10px;
            background: #e8e4fa;
          }

          .t-progress-fill {
            height: 100%;
            border-radius: inherit;
            background: linear-gradient(90deg, #4c3a8f, #a29bfe);
            transition: width 0.35s ease;
          }

          .t-carousel-wrapper {
            display: flex;
            align-items: center;
            gap: 9px;
          }

          .t-carousel-viewport {
            min-width: 0;
            flex: 1;
            overflow: hidden;
            border-radius: 16px;
          }

          .t-slider-track {
            display: flex;
            align-items: stretch;
            transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .t-slide-card {
            min-width: 100%;
            padding: 24px 20px;
            border: 1px solid #e9e7f1;
            border-radius: 16px;
            background: #fff;
            box-shadow: 0 8px 25px rgba(36, 24, 74, 0.06);
          }

          .t-arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            flex: 0 0 36px;
            padding: 0;
            border: none;
            border-radius: 50%;
            background: #5944c5;
            color: #fff;
            cursor: pointer;
            transition: transform 0.2s ease;
          }

          .t-arrow:hover {
            transform: scale(1.06);
          }

          .t-dots {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            gap: 7px;
            margin-top: 18px;
          }

          .t-dot {
            width: 7px;
            height: 7px;
            padding: 0;
            border: 0;
            border-radius: 10px;
            background: #d7d0f6;
            cursor: pointer;
            transition: width 0.25s ease, background 0.25s ease;
          }

          .t-dot.active {
            width: 22px;
            background: #5944c5;
          }

          .tf-faq {
            margin-top: 60px;
          }

          .tf-faq .section-title {
            margin-bottom: 10px;
          }

          .faq-intro {
            margin-bottom: 25px;
            font-size: 13px;
          }

          .faq-list {
            gap: 11px;
          }

          .faq-question {
            padding: 16px;
            font-size: 14px;
            gap: 12px;
          }

          .faq-icon {
            width: 29px;
            height: 29px;
            flex-basis: 29px;
          }

          .faq-answer p {
            padding: 0 16px 17px;
            font-size: 13px;
            line-height: 1.8;
          }

          .faq-btn {
            width: 100%;
            max-width: 320px;
            padding: 13px 20px;
            font-size: 13px;
          }
        }

        @media (max-width: 380px) {
          .tf-section {
            padding-right: 12px;
            padding-left: 12px;
          }

          .tf-section .section-title {
            font-size: 23px;
          }

          .t-arrow {
            width: 30px;
            height: 30px;
            flex-basis: 30px;
          }

          .t-carousel-wrapper {
            gap: 6px;
          }

          .t-slide-card {
            padding: 20px 15px;
          }

          .faq-question {
            padding: 14px 12px;
            font-size: 13px;
          }

          .faq-answer p {
            padding-right: 12px;
            padding-left: 12px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .tf-section *,
          .tf-section *::before,
          .tf-section *::after {
            scroll-behavior: auto !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>

      <section className="tf-section">
        <div className="tf-testimonials">
          <h2 className="section-title">Customer Reviews</h2>

          <div className="testimonial-container">
            {testimonials.map((item, index) => (
              <article className="testimonial-card" key={item.name}>
                <div className="review-header">
                  <div
                    className="avatar"
                    style={{
                      background: avatarColors[index % avatarColors.length],
                    }}
                  >
                    {item.name.charAt(0)}
                  </div>

                  <div className="review-user">
                    <h4>{item.name}</h4>
                    <span>{item.date}</span>
                  </div>

                  <div className="google-logo" aria-label="Google review">
                    G
                  </div>
                </div>

                <div
                  className="stars"
                  aria-label={`${item.rating} out of 5 stars`}
                >
                  {"★".repeat(item.rating)}
                  {"☆".repeat(5 - item.rating)}
                </div>

                <p className="review-text">{item.review}</p>
              </article>
            ))}
          </div>

          <div className="mobile-testimonial-slider">
            <div className="t-progress-bar" aria-hidden="true">
              <div
                className="t-progress-fill"
                style={{
                  width: `${((currentSlide + 1) / testimonials.length) * 100}%`,
                }}
              />
            </div>

            <div className="t-carousel-wrapper">
              <button
                type="button"
                className="t-arrow"
                onClick={() => {
                  goToPrev();
                  pauseAndResume();
                }}
                aria-label="Previous review"
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M15 19l-7-7 7-7"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <div
                className="t-carousel-viewport"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                <div
                  className="t-slider-track"
                  style={{
                    transform: `translateX(-${currentSlide * 100}%)`,
                  }}
                >
                  {testimonials.map((item, index) => (
                    <article className="t-slide-card" key={item.name}>
                      <div className="review-header">
                        <div
                          className="avatar"
                          style={{
                            background:
                              avatarColors[index % avatarColors.length],
                          }}
                        >
                          {item.name.charAt(0)}
                        </div>

                        <div className="review-user">
                          <h4>{item.name}</h4>
                          <span>{item.date}</span>
                        </div>

                        <div className="google-logo" aria-label="Google review">
                          G
                        </div>
                      </div>

                      <div
                        className="stars"
                        aria-label={`${item.rating} out of 5 stars`}
                      >
                        {"★".repeat(item.rating)}
                        {"☆".repeat(5 - item.rating)}
                      </div>

                      <p className="review-text">{item.review}</p>
                    </article>
                  ))}
                </div>
              </div>

              <button
                type="button"
                className="t-arrow"
                onClick={() => {
                  goToNext();
                  pauseAndResume();
                }}
                aria-label="Next review"
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M9 5l7 7-7 7"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div className="t-dots" aria-label="Choose a customer review">
              {testimonials.map((item, index) => (
                <button
                  type="button"
                  key={item.name}
                  className={`t-dot ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => {
                    setCurrentSlide(index);
                    pauseAndResume();
                  }}
                  aria-label={`Show review ${index + 1}`}
                  aria-current={index === currentSlide ? "true" : undefined}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="tf-faq" id="frequently-asked-questions">
          <h2 className="section-title">Frequently Asked Questions</h2>

          <p className="faq-intro">
            Find answers about HexaPlay private theatres, celebrations, gaming
            and booking your experience.
          </p>

          <div className="faq-list">
            {faqs.map((faq, index) => {
              const isOpen = activeIndex === index;
              const answerId = `faq-answer-${index}`;

              return (
                <article
                  className={`faq-card ${isOpen ? "active" : ""}`}
                  key={faq.question}
                >
                  <h3 style={{ margin: 0, fontSize: "inherit" }}>
                    <button
                      type="button"
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isOpen}
                      aria-controls={answerId}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon" aria-hidden="true">
                        +
                      </span>
                    </button>
                  </h3>

                  <div
                    className="faq-answer"
                    id={answerId}
                    aria-hidden={!isOpen}
                  >
                    <div className="faq-answer-inner">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <div className="faq-btn-wrapper">
            <a href="/FAQPage" className="faq-btn">
              Still Have Questions? Contact Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsFaq;
